import React from 'react';
import { StaticQuery, graphql } from 'gatsby';
import { Tooltip } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFileArchive, faFileCode, faLink, faFilePdf, faFile } from '@fortawesome/free-solid-svg-icons'
import { faGithubSquare } from '@fortawesome/free-brands-svg-icons'



const getIcon = (icon) => {
    if (icon == 'zip') {
        return faFileArchive
    }
    else if( icon == 'pdf') {
        return faFilePdf
    }
    else if( icon == 'code') {
        return faFileCode
    }
    else if( icon == 'link') {
        return faLink
    }
    else if( icon == 'github') {
        return faGithubSquare
    }
    else if( icon == 'github') {
        return faGithubSquare
    }
    else {
        return faFile
    }
}


const ResFile = props => (
    <StaticQuery
        query={graphql`
          query {
            files: allFile {
              edges {
                node {
                  relativePath
                  name
                  base
                  publicURL
                }
              }
            }
          }
    `}
    render={data => {
        let url = ""
        if(props.filename) {
            const file = data.files.edges.find(n => {
                return n.node.base.includes(props.filename);
            });
            if(file) {
            url = file.node.publicURL
            }
        }
        else {
            url = props.url
        }

        return (
            <a href={url} title={props.desc} >
                <FontAwesomeIcon {...props} icon={getIcon(props.icon)} />
            </a>
        )

    }}
/>
);

export default ResFile

